export default __webpack_public_path__ + "static/media/toh_preview_v00.68adb599.png";